// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + "main" + "." + "b5d60102d4ea3c15449c" + ".css";
};